//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import loading from '@/components/public-components/loading/index.vue'
import Cpts013 from '@/components/lyx-components/lyx-footer/index.vue'
import goBack from '@/components/public-components/goBack/index.vue'

export default {
  components: {
    loading,
    Cpts013,
    goBack
  },
  data () {
    return {
      minHeight: 0
    }
  },
  mounted () {
    this.minHeight = document.documentElement.clientHeight
    document.title = '投诉'
  }
}
